import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Übersicht',
      href: '/de/Aussenkameras/IN-5905_HD/',
    },
    {
      text: 'Specifications',
      href: '/de/Aussenkameras/IN-5905_HD/Technische_Spezifikationen/',
    },
    {
      text: 'Features',
      href: '/de/Aussenkameras/IN-5905_HD/Produkt_Features/',
    },
    {
      text: 'Installation',
      href: '/de/Aussenkameras/IN-5905_HD/Schnell_Installation/',
    },
    {
      text: 'P2P',
      href: '/de/Aussenkameras/IN-5905_HD/Point2Point/',
    },
    {
      text: 'Objektivjustage',
      href: '/de/Aussenkameras/IN-5905_HD/Objektivjustage/',
    },
    {
      text: 'Handbuch',
      href: '/de/Aussenkameras/IN-5905_HD/Handbuch/',
    },
    {
      text: '◄ Aussenkameras',
      href: '/de/Aussenkameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-5905 HD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}

// export default () => {
//   const breadcrumbs = [
//     {
//       text: 'Overview',
//       href: '/Aussenkameras/IN-5905_HD/',
//     },
//     {
//       text: 'Technical Specifications',
//       href: '/Aussenkameras/IN-5905_HD/Technical_Specifications/',
//     },
//     {
//       text: 'Product Features',
//       href: '/Aussenkameras/IN-5905_HD/Product_Features/',
//     },
//     {
//       text: 'Installation',
//       href: '/Aussenkameras/IN-5905_HD/Quick_Installation/',
//     },
//     {
//       text: 'P2P Installation',
//       href: '/Aussenkameras/IN-5905_HD/Point2Point/',
//     },
//     {
//       text: 'Lense Adjustment',
//       href: '/Aussenkameras/IN-5905_HD/Lense_Adjustment/',
//     },
//     {
//       text: '◄ Usermanual',
//       href: '/Aussenkameras/IN-5905_HD/Usermanual/',
//     }
//   ];

//   return (
//     <Fragment>
//       <EuiBreadcrumbs
//         truncate={true}
//         breadcrumbs={breadcrumbs}
//         max={7}
//         aria-label="INSTAR IN-5905 HD Online Usermanual Chapters"
//       />
//       <EuiSpacer />
//     </Fragment>
//   );
// }